(ns common.url
  (:require [clojure.string :as string]))

(def simple-uri-pattern #"([a-zA-Z]*://)?([a-zA-Z0-9@:%_\-\+~#=]{1,256})*\.?([a-zA-Z0-9@:%_\-\+~#=]{1,256})\.([a-zA-Z0-9()]{1,6})([-a-zA-Z0-9()@:%_\-\+.~#?&//=]*)")

(defn valid-url? [url]
  (re-matches simple-uri-pattern url))

;; note: this is used for on-change handler => does not add protocol
;;  if url starts with (https|http|htt|ht|h). for on-save/similar, use
;;  prepend-protocol below
(defn string->protocol-url
  ([s] (string->protocol-url s :http))
  ([s preferred-protocol]
   (if s
     (let [maybe-url-pattern
           #"^(([a-zA-Z]+://)|([a-zA-Z]+:/)|([a-zA-Z]+:)|(https|http|htt|ht|h)|(file:))"
           after-protocol (string/replace s maybe-url-pattern "")]
       (if (and (not (re-find maybe-url-pattern s))
                (> (count after-protocol) 4))
         (str (if (= preferred-protocol :http) "http://" "https://")
              after-protocol)
         s)))))

(defn has-protocol? [url]
  (let [protocols [:https :http :file]]
    (->> protocols
         (map name)
         (map #(str % "://"))
         (some (fn [protocol]
                 (string/starts-with? (str url) protocol))))))

(defn prepend-protocol
  ([url]
   (prepend-protocol url :https))
  ([url protocol]
   (if (or (nil? url)
           (and (string? url)
                (string/blank? url))
           (has-protocol? url))
     url
     (str (name protocol) "://" url))))

(defn relative-or-protocol-url
  ([s] (relative-or-protocol-url s :https))
  ([s preferred-protocol]
   (cond (not (string? s))
         s
         ;; if string starts with "/", such as "/img/spinner.gif",
         ;;  assume its relative to zapflow domain => don't add http(s)
         (string/starts-with? (str s) "/")
         s
         (re-find #"[a-zA-Z]+:" (str s))
         (prepend-protocol s :file)

         ;; if string is shorter than 5 chars - do not prepend protocol yet
         (< (count (str s)) 5)
         s
         :else
         (prepend-protocol s preferred-protocol))))

(defn strip-querystring [url]
  (some-> url
          (string/split #"\?")
          (first)))
